import { DialogProps } from "@mcleod/components";
import { AbstractPanelOpenTree } from "./AbstractPanelOpenTree";

export class PanelOpenFieldList extends AbstractPanelOpenTree {
    override getDialogProps(): Partial<DialogProps> {
        return {
            ...super.getDialogProps(),
            cursor: null
        };
    }

    protected override getTitle(): string {
        return "Field List Selection";
    }

    override getApiName(): string {
        return "field-list/list";
    }

    override getCustomizedTooltip(): string {
        return "This is a field list.";
    }
}
